import { environment } from 'src/environments/environment';

export let urlConfig: any = {
};

export function setURLConfig() {
  urlConfig = {
    layoutImageUrl: environment.BaseUrl + '/layout/GetSeatingAreaLayoutImage?restaurantId=',
    getWidgetSettings: environment.BaseUrl + '/widget/GetRestaurantWidgetsettings',
    getWidgetSettingsByMerchantCode:  environment.BaseUrl + '/customwidget/GetMerchantWidgetSettings',
    seatingTypesUrl: environment.BaseUrl + '/widget/GetSeatingTypes?restaurantId=',
    layoutUrl: environment.BaseUrl + '/layout/GetLayoutInformation',
    // ?restaurantId=14&timeSlot=2020-12-14T21%3A00%3A00&partySize=2&seatingareaid=&showCommunalTable=false&_=1607622941552',
    bannerImageUrl: environment.BaseUrl + '/widget/GetWidgetImage',
    dateAvailabilityUrl: environment.BaseUrl + '/widget/GetRestaurantDateAvailability',
    availableDateUrl: environment.BaseUrl + '/widget/GetRestaurantAvailableDates',
    restaurantPolicy: environment.BaseUrl + '/widget/GetRestaurantPolicy',
    getCustomGuestFields: environment.BaseUrl + '/widget/GetCustomGuestFields',
    getCountries: environment.BaseUrl + '/widget/GetCountries',
    getContact: environment.BaseUrl + '/widget/Get',
    acquireLock: environment.BaseUrl + '/lock/Acquire',
    releaseLock: environment.BaseUrl + '/lock/Release',
    getPreliminaryReservationInformation: environment.BaseUrl + '/reservation/GetPreliminaryReservationInformation',
    getCoverTypePricing: environment.BaseUrl + '/reservation/GetCoverTypePricing',
    createReservation: environment.BaseUrl + '/reservation/Create',
    updateReservation: environment.BaseUrl + '/reservation/Update',
    cancelReservation: environment.BaseUrl + '/reservation/Cancel',
    registerReservationAttempt: environment.BaseUrl + '/reservation/RegisterReservationAttempt',
    updateReservationAttempt: environment.BaseUrl + '/reservation/UpdateReservationAttempt',
    completeShift4Booking: environment.BaseUrl + '/reservation/CompleteShift4Booking',
    getReservationAttemptState: environment.BaseUrl + '/reservation/GetReservationAttemptState',
    getByToken: environment.BaseUrl + '/reservation/GetByToken',
    getByTokenForCommentCard: environment.BaseUrl + '/reservation/GetByTokenForCommentCard',
    formatResult: environment.BaseUrl + '/reservation/FormatResult',
    getFinancialEffectForUpdatedReservationDTO: environment.BaseUrl + '/reservation/GetFinancialEffectForUpdatedReservationDTO',
    getSpecialMeal: environment.BaseUrl + '/reservation/GetSpecialMeal',
    getAuthWaiverForm: environment.BaseUrl + '/widget/GetAuthWaiverForm',
    getImages: environment.BaseUrl + '/widget/GetImages?restaurantId=',
    widgetImageURL: '/widget/GetWidgetImage?id=',
    getMerchantLevelImageUrl:  environment.BaseUrl + '/widget/GetWidgetImage',
    createSecondaryContacts: environment.BaseUrl + '/reservation/SetSecondaryContacts',
    backgroundImageUrl: environment.BaseUrl + '/widget/GetWidgetBackgroundImage',
    GetSlotsForActivityURL: environment.BaseUrl + '/Activities/GetAvailability',
    getGetFilteredLessonsActivityURL: environment.BaseUrl + '/activities/GetFilteredLessons',
    lockSessionsURL: environment.BaseUrl + '/Activities/LockSessions',
    lockMultiSessionsURL: environment.BaseUrl + '/customwidget/LockCartForMultipleProperties',
    unLockMultiSessionsURL: environment.BaseUrl + '/customwidget/UnlockCartForMultipleProperties',
    // registerMultiReservationAttempt: environment.BaseUrl + '/customwidget/RegisterMultipleReservationAttemptsForActivitiesCart',
    registerMultiReservationAttempt: environment.BaseUrl + '/customwidget/RegisterMultipleReservationAttempts',
    registerMultiReservationAttemptUniversalCart: environment.BaseUrl + '/customwidget/RegisterReservationAttempt',
    GetRatePlanCalculatedURL: environment.BaseUrl + '/Activities/GetRatePlanCalculated',
    createSessionBookingURL: environment.BaseUrl + '/Activities/BookHostActivity',
    createMultiSessionBookingURL: environment.BaseUrl + '/customwidget/BookCartForMultipleProperties',
    updateSessionBookingURL: environment.BaseUrl + '/Activities/UpdateHostActivity',
    GetPreliminaryActivityInformationURL: environment.BaseUrl + '/Activities/GetPreliminaryActivityInformation',
    registerBookActivityAttempt: environment.BaseUrl + '/reservation/RegisterBookActivityAttempt',
    updateMultipleBookActivityAttempt: environment.BaseUrl + '/reservation/UpdateMultipleReservationAttempts',
    getFinancialEffectForUpdatedActivityDTO: environment.BaseUrl + '/activities/FinancialEffect',
    cancelSessionBooking: environment.BaseUrl + '/Activities/CancelClassOrSession',
    GetCancellationChargeURL: environment.BaseUrl + '/Activities/GetCancellationCharge',
    cancelStandByBooking: environment.BaseUrl + '/Activities/CancelStandByClassOrSession',
    GetContactFromEngagebyCardnoURL: environment.BaseUrl + '/activities/GetContactFromEngagebyCardno',
    GetSlotsForTablesURL: environment.BaseUrl + '/activities/GetOpenBookingSlotsForTables',
    getsurveyurl: environment.BaseUrl + '/Feedback/GetSurveyrequest',
    updatesurveyurl: environment.BaseUrl + '/Feedback/Update',
    layoutseatingImageUrl: environment.BaseUrl + '/Feedback/GetFeedbackLayoutImage?restaurantId=',
    lockTablesURL: environment.BaseUrl + '/Activities/AcquireMultiple',
    getMultipleReservationAttemptStates: environment.BaseUrl + '/activities/GetMultipleReservationAttemptStates',
    BookMultipleActivity: environment.BaseUrl + '/activities/BookMultipleActivity',
    getByBookingId: environment.BaseUrl + '/activities/GetByBookingId',
    cancelOpenBookingUrl: environment.BaseUrl + '/activities/CancelMultipleOpenBooking',
    releaseMultipleLocks: environment.BaseUrl + '/Activities/ReleaseMultiple',
    unlockSessionsUrl: environment.BaseUrl + '/Activities/UnLockSessions',
    getCommentCardCustomization: environment.BaseUrl + '/Feedback/GetCommentCardCustomization',
    deleteCartItem: environment.BaseUrl + '/Activities/deleteCart',
    AddToCartItem: environment.BaseUrl + '/Activities/addToCart',
    bookSelectedCartItems: environment.BaseUrl + '/Activities/bookSelectedCartItems',
    bookPrivateLesson: environment.BaseUrl + '/activities/CreateStandByPrivateLessonWebsiteActivity',
    cancelPrivateLessonUrl: environment.BaseUrl + '/activities/CancelPrivateLesson',
    LockCartSessionURL: environment.BaseUrl + '/Cart/LockCart',
    UnlockCartSessionURL: environment.BaseUrl + '/Cart/UnlockCart',
    getCartReservationAttempt: environment.BaseUrl + '/Cart/RegisterCartBookActivityAttempts',
    bookCart: environment.BaseUrl + '/Cart/BookCart',
    validateCartCustomFields: environment.BaseUrl + '/Cart/ValidateCartItem',
    validateCartItem: environment.BaseUrl + '/Cart/ValidateCartItem',
    openBookingLayoutUrl: environment.BaseUrl + '/layout/GetOpenBookingLayoutInformation',
    openBookingAddOnsUrl: environment.BaseUrl + '/widget/GetAddonsAvailabilityBySlot',
    openBookingCancelUrl: environment.BaseUrl + `/Activities/CancelOpenBooking`,
    getLanguageConstants : environment.BaseUrl + '/widget/GetLanguageConstant',
    SearchByBookingType : environment.BaseUrl + '/Reservation/SearchByBookingType',
    getRateplan:  environment.BaseUrl + '/Activities/GetRatePlanCalculated',
    WildSearchEngageMemberURL: environment.BaseUrl + '/Reservation/WildSearchEngageMember',
    getCustomStyleSheet: environment.BaseUrl + '/GetCustomStyleSheet',
    getCustomLiterals: environment.BaseUrl + '/GetCustomLiterals',

  };
}

export enum loaderDisabledUrls {
};

